<template>
    <div class="CourseBox">
      <template v-if="$route.name === 'course'">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->
        <div class="searchCon">
          <div class="searchMain">
            <ots-refer
                :selectList="selectList"
                :request-form="selectForm"
                @search="getResult"
            />
          </div>
        </div>
        <!-- 列表 -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableOption="tableOption"
            :tableData="tableData"
            :batchOperBtn="batchOperBtn"
            @handleSelectionChange="bachOper"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
        <!-- 弹窗 -->
        <ots-custom-dialog :dialog.sync="addDialog" :title="form.code?'修改':'课程设置'" width="40%">
            <template v-slot:content>
                <div>
                    <el-form ref="form" :model="form" :rules="rules">
                        <el-form-item label="课程名称" class="childrenName" prop="name">
                            <el-input v-model.trim="form.name" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="启用状态">
                            <el-radio-group v-model="form.state">
                                <el-radio-button label=1>启用</el-radio-button>
                                <el-radio-button label=0>停用</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否综合课">
                            <el-radio-group v-model="form.haveSubCourse" @change="changeHaveSubCourse">
                                <el-radio-button label=1>是</el-radio-button>
                                <el-radio-button label=0>否</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="通过分数设置 大于等于" prop="passScore">
                            <el-input v-model="form.passScore" maxlength="3"></el-input> 分
                        </el-form-item>
                        <el-form-item label="优秀分数设置 大于等于" prop="excellentScore">
                            <el-input v-model="form.excellentScore" maxlength="3"></el-input> 分
                        </el-form-item>
                        <el-form-item label="成绩计算方式">
                            <el-radio-group v-model="form.scoreCalculateType">
                                <el-radio-button label=1>原始成绩</el-radio-button>
                                <el-radio-button label=2>赋分后成绩</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="成绩显示方式">
                            <el-radio-group v-model="form.scoreType" @change="changeSwitchState">
                                <el-radio-button label=1>分数</el-radio-button>
                                <el-radio-button label=2 :disabled="form.haveSubCourse==1?true:false">等级制</el-radio-button>
                                <el-radio-button label=3>合格/不合格</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <div class="courseSwitchCss" :style="arrowPositionStyle" v-if="isShowSwitch">
                          <div class="switch1" v-if="form.scoreType == 2 || form.scoreType == 3">
                            <div>是否同时显示分数 <el-switch v-model="form.outputScore" :active-value="1" :inactive-value="0" @change="form.outputScoreSub = 0"></el-switch></div>
                            <div><font>（如开启，学生会在成绩查询页面看到具体分数）</font></div>
                          </div>
                          <div class="switch1" v-if="form.haveSubCourse == 1 && form.scoreType == 3 && form.outputScore == 1">
                            <div>是否显示综合课的单科分数 <el-switch v-model="form.outputScoreSub" :active-value="1" :inactive-value="0"></el-switch></div>
                            <div><font>（如开启，学生会查询到综合课下的单科得分）</font></div>
                          </div>
                        </div>
                        <!-- <el-form-item label="合格率百分比" class="rateStyle" v-if="form.scoreType == 3">
                            <el-input class="short" v-model="form.rate" placeholder="请输入"></el-input><em>%</em>
                        </el-form-item> -->
                        <el-form-item label="等级设置" class="gradeStyle" v-if="form.scoreType == 2">
                          <div v-for="(item, index) in form.form_gradeList" :key="index" class="mb10">
                            <el-input class="input-w160"  placeholder="请输入等级名称" v-model="item.name"></el-input>
                            <span class="span-w">分数≥</span>
                            <el-input class="short" placeholder="录入等级分数" v-model="item.score"></el-input>
                            <i v-if="index > 0" class="ml42 iconfont icon-shanchu" @click="deleteGrade(index)"></i>
                          </div>
                          <p class="col_blue mt10 cp" @click="addGrade"><i class="el-icon-plus mr5"></i><span>增加等级</span></p>
                        </el-form-item>

                        <el-form-item label="是否使用计算器">
                            <el-radio-group v-model="form.useCalculator">
                                <el-radio-button label=0>不使用</el-radio-button>
                                <el-radio-button label=1>使用</el-radio-button>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="是否需要特殊输入法">
                            <el-radio-group v-model="form.specialInputting">
                                <el-radio-button label=''>不需要</el-radio-button>
                                <el-radio-button label='JP'>日语</el-radio-button>
                                <el-radio-button label='RU'>俄语</el-radio-button>
                            </el-radio-group>
                        </el-form-item>


                        <!-- <el-form-item label="是否需要特殊输入法（多）">
                          <el-checkbox-group v-model="checkList">
                            <el-checkbox label=""></el-checkbox>
                            <el-checkbox label="JP"></el-checkbox>
                            <el-checkbox label="RU"></el-checkbox>
                          </el-checkbox-group>
                        </el-form-item> -->



                        <el-form-item label="是否需要麦克风">
                            <el-radio-group v-model="form.useMicroPhone">
                                <el-radio-button label=0>不需要</el-radio-button>
                                <el-radio-button label=1>需要</el-radio-button>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="是否允许申请免考">
                            <el-radio-group v-model="form.exemptExam">
                                <el-radio-button label=1>是</el-radio-button>
                                <el-radio-button label=0>否</el-radio-button>
                            </el-radio-group>
                        </el-form-item>

                    </el-form>
                </div>
            </template>
            <template v-slot:footer>
                <el-button round @click="cancelDialog">取消</el-button>
                <el-button round type="primary" @click="addCourse">确定</el-button>
            </template>
        </ots-custom-dialog>

        <!-- 导入弹窗 -->
        <ots-custom-dialog :dialog.sync="importCourseDialog" title="导入课程" width="40%">
          <template v-slot:content>
            <div class="exportDialog">
              <el-form ref="exportForm" :model="importForm">
                <el-form-item label="1.模板下载">
                  <span style="color: #006aff" @click="$getStaticFile('课程导入模板.xlsx')" class="cp">
                    <i class="el-icon-download"></i>
                    下载课程导入模板
                  </span>
                </el-form-item>
                <el-form-item label="3.选择文件" v-model="importForm.file">
                  <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
                </el-form-item>
              </el-form>
              <div class="impExplain">
                <span class="tipTitle"><i></i>提示：</span>
                <div>
                  <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                  <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="importCourseDialog = false">取消</el-button>
            <el-button round type="primary" @click="rightImportCourse">确定</el-button>
          </template>
        </ots-custom-dialog>
      </template>
      <template v-else>
        <router-view></router-view>
    </template>
    </div>
</template>
<script>

import { getAllCourse, addCourseFn, updateCourseFn, deleteCourseFn, updateCourseStateFn, getSpecialInputtingAPI, importCourseAPI, exportCourseListAPI } from '@/http/modules/baseSet/course'
const scoreType = {
  1: "分数",
  2: "等级制",
  3: "合格/不合格"
}
const scoreCalculateType = {
  1: "原始成绩",
  2: "赋分后成绩"
}
export default {
  name: 'Course',
  data () {
    return {
      checkList: [],
      selectIds: [],
      selectList: [
        {
          title: "状态",
          type: "select",
          requestKey: "state",
          label: 'key',
          value: 'value',
          data: [
            {
              key : '全部',
              value : -1
            },
            {
              key : '启用',
              value : 1
            },
            {
              key : '停用',
              value : 0
            }
          ],
        },
        {
          title : '课程名称',
          type : 'input',
          placeholder : '请输入课程名称',
          requestKey: "searchKey"
        },
        {
          title:'成绩计算方式',
          type:'select',
          requestKey:'scoreCalculateType',
          label:'name',
          value:'id',
          data:[
            {id:'',name:'全部'},
            {id:'1',name:'原始成绩'},
            {id:'2',name:'赋分后成绩'}
          ]
        },
        {
          title:'成绩显示方式',
          type:'select',
          requestKey:'scoreType',
          label:'name',
          value:'id',
          data:[
            {id:'',name:'全部'},
            {id:'1',name:'分数'},
            {id:'2',name:'等级制'},
            {id:'3',name:'合格/不合格'},
          ]
        },
        {
          title:'是否综合课',
          type:'select',
          requestKey:'haveSubCourse',
          label:'name',
          value:'id',
          data:[
            {id:'',name:'全部'},
            {id:'1',name:'是'},
            {id:'0',name:'否'},
          ]
        },
        {
          title: '是否需要特殊输入法',
          type: 'select',
          requestKey: 'specialInputting',
          label: 'name',
          value: 'id',
          data: [
            {id: '', name: '全部'},
          ]
        },
        {
          title: '是否使用计算器',
          type: 'select',
          requestKey: 'useCalculator',
          label: 'name',
          value: 'id',
          data: [
            {id: '', name: '全部'},
            {id: '1', name: '是'},
            {id: '0', name: '否'},
          ]
        },
        {
          title: '是否使用麦克风',
          type: 'select',
          requestKey: 'useMicroPhone',
          label: 'name',
          value: 'id',
          data: [
            {id: '', name: '全部'},
            {id: '1', name: '是'},
            {id: '0', name: '否'},
          ]
        },
        {
          title: "是否允许申请免考",
          type: "select",
          requestKey: "exemptExam",
          label: "name",
          value: "id",
          data: [
            {id: '', name: '全部'},
            {id: '1', name: '是'},
            {id: '0', name: '否'},
          ]
        }
      ],
      selectForm: {
        state : -1,
        searchKey : '',
        scoreCalculateType : "",
        scoreType: "",
        exemptExam: "",
        specialInputting: '',
        useCalculator: '',
        useMicroPhone: '',
        haveSubCourse: '',
      },
      tableHeader: [
          {
              title: "课程名称",
              prop: "name"
          },
          {
              title:"成绩计算方式",
              prop:"scoreCalculateType",
              width:"120",
              formatter: (val) => scoreCalculateType[val.row.scoreCalculateType]
          },
          {
              title:"成绩显示方式",
              prop:"scoreType",
              width:"120",
              formatter: (val) => scoreType[val.row.scoreType]
          },
          {
            title: "是否需要特殊输入法",
            prop: "specialInputting",
            formatter: (val) => !val.row.specialInputting ? '-' : val.row.specialInputting == 'JP' ? '日语': '俄语',
          },
          {
            title: "是否使用计算器",
            prop: "useCalculator",
            formatter: (val) => val.row.useCalculator == 1 ? "是": "否",
          },
          {
            title: "是否使用麦克风",
            prop: "useMicroPhone",
            formatter: (val) => val.row.useMicroPhone == 1 ? "是": "否",
          },

          {
            title: "是否允许申请免考",
            prop: "exemptExam",
            formatter: (val) => val.row.exemptExam == 1 ? "是": "否",
          },
          {
            title: "是否综合课",
            prop: "haveSubCourse",
            formatter: (val) => val.row.haveSubCourse == 1 ? "是": "否",
          },
          {
            title: "是否同时显示分数",
            prop: "outputScore",
            formatter: (val) => val.row.outputScore == 1 ? "是": "否",
          },
          {
            title: "是否显示综合课的单科分数",
            prop: "outputScoreSub",
            formatter: (val) => val.row.outputScoreSub == 1 ? "是": "否",
          },
          {
              title:"启用状态",
              prop:"state",
              type:"switch",
              switchChange:this.changeCourseState
          },
          {
              title:"操作",
              type:"buttons",
              width:"140",
              btnList:[
                  {
                      title:"设置单科",
                      click: this.setSubCourse,
                      formatter : (val) => val.row.haveSubCourse == 0 ? '---' : '设置单科',
                      disableFn : (val) => val.row.haveSubCourse == 0
                  },
                  {
                      title:"编辑",
                      click: this.editCourse
                  },
                  {
                      title:"删除",
                      click: this.deleteCourse
                  },
              ]
          }
      ],
      tableOption: {
          multiple:true
      },
      batchOperBtn:[
          {
              title: "删除",
              icon: "iconfont icon-shanchu",
              click: this.deleteCourse
          },
      ],
      tableData: [],
      form: {
        passScore:'',
        excellentScore:'',
        exemptExam: 0,
        name: '',
        state: 1,
        scoreCalculateType: 1,
        scoreType: 1,
        rate: 60,
        form_gradeList: [
          {score: 85, name: '优秀'},
          {score: 60, name: '及格'}
        ],
        useCalculator: 0,
        useMicroPhone: 0,
        specialInputting: '',
        haveSubCourse: 0,
        outputScore: 0,
        outputScoreSub: 0,
      },
      importForm: {
        file: ''
      },
      rules: {
        passScore: [
          { required: true, message: "请输入通过分数", trigger: "blur" },
          //{ type: "number", message: "通过分数只能为数字", trigger: "blur" },
        ],
        excellentScore: [
          { required: true, message: "请输入优秀分数", trigger: "blur" },
          // { type: "number", message: "优秀分数只能为数字", trigger: "blur" },
        ],
        name: [
          { required: true, message: '请输入课程名称', trigger: 'blur'},
          { min: 1, max: 30, message: '输入范围在 1 到 30 个字符', trigger: 'blur' }
        ],

      },
      mainTopBtnList: [
        {
          title: '新增',
          plain: true,
          fn: this.addCourseDialog
        },
        {
          title: '导入',
          fn: this.importCourse
        },
        {
          title: "导出",
          fn: this.exportExcel
        }
      ],
      addDialog: false,
      importCourseDialog: false,
      pagination: {
        total: 0
      },
      CourseListParams: {
        orders: 'createDate desc',
        page: 1,
        size: 10
      }
    }
  },
  created () {
    if (this.$route.query && this.$route.query.name) {
      this.selectForm.searchKey = this.$route.query.name
    }
    this.initData();
  },

  mounted() {
    this.getAllCourseFn()
  },

  computed: {
    arrowPositionStyle() {
      if(this.form.scoreType == 1) {
        return {'--arrow-position': `35px`,}
      }else if(this.form.scoreType == 2) {
        return {'--arrow-position': `120px`,}
      }else{
        return {'--arrow-position': `235px`,}
      }
    },
    isShowSwitch() {
      return this.form.scoreType == 2 || this.form.scoreType == 3;
    }
  },

  methods: {
    async exportExcel() {
      let params = {...this.selectForm}
      const { data, code } = await exportCourseListAPI(params);
      if (code) {
        window.open(data);
      }
    },

    handleFormData(val) {
      this.importForm.file = val.file;
    },

    async rightImportCourse() {
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }

      const { code, data } = await importCourseAPI(fd);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const totalNum = parseInt(data.allCount);
        const successNum = totalNum - failNum;

        let message = `导入完成，成功导入${successNum}条，失败${failNum}条。`;
        this.importCourseDialog = false;

        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        }).catch(() => {});

        this.getAllCourseFn();
      }

    },

    // 导入
    importCourse() {
      this.importCourseDialog = true;
    },

    // 获取表单配置数据
    async initData() {
      const { data } = await getSpecialInputtingAPI();
      var result = data.map(o=>{return{id:o.inputCode, name:o.inputName}});
      this.selectList[4].data = [...this.selectList[4].data, ...result];
    },

    addGrade () {
      let obj = {
        score: '',
        name: ''
      }
      this.form.form_gradeList.push(obj)
    },
    deleteGrade (index) {
      this.form.form_gradeList.splice(index, 1)
    },
    bachOper (val) {
      let idList=[]
      val.forEach(item=>{
          idList.push(item.id)
      })
      this.selectIds = idList
    },
    addCourseDialog () {
      this.resetForm()
      this.addDialog = true
    },
    cancelDialog () {
      this.resetForm()
      this.addDialog = false
    },
    addCourse () {
      this.$refs['form'].validate(async (valid) => {
          if (valid) {
              let params = {
                name: this.form.name,
                scoreCalculateType: this.form.scoreCalculateType,
                scoreType: this.form.scoreType,
                state: this.form.state,
                passScore :this.form.passScore,
                excellentScore: this.form.excellentScore,
                useCalculator: this.form.useCalculator,
                useMicroPhone: this.form.useMicroPhone,
                specialInputting: this.form.specialInputting,
                exemptExam: this.form.exemptExam,
                haveSubCourse: this.form.haveSubCourse,
                outputScore: this.form.outputScore,
                outputScoreSub: this.form.outputScoreSub
              }
              if(this.form.haveSubCourse == 1 && this.form.scoreCalculateType == 2){
                this.$message.error('综合课不能选择赋分后成绩的计算方式')
                return false;
              }
              if (this.form.scoreType == 2) { // 等级制
                let gradeSet = this.form.form_gradeList.filter(item => item.name)
                if (!gradeSet.length) {
                  this.$message.error('请设置有效的等级制')
                  return false
                }
                params.gradeSet = JSON.stringify(gradeSet)
              }
              // 处理编辑还是新增
              if (this.form.id) {
                params.id = this.form.id
              }
              const useFn = params.id ? updateCourseFn : addCourseFn
              const { code } = await useFn(params)
              if (code ==  1) {
                this.$message.success('操作成功')
                this.addAfter()
              }
          } else {
              return false;
          }
      });
    },
    setSubCourse (row) {
      this.$router.push({
        name: "addSubCourse",
        query: {
          courseId: row.id,
          courseName : row.name
        },
      });
    },
    editCourse (row) {
      if (!row.specialInputting) {
        row.specialInputting = ''
      }
      this.form = Object.assign(this.form, row)
      if (row.scoreType == 2 && row.gradeSet) {
        this.form.form_gradeList = JSON.parse(row.gradeSet)
      }
      this.addDialog = true
    },
    beforeBatch () {
      if (this.selectIds.length > 0) {
        return true
      } else {
        this.$message.warning('请先选择课程')
        return false
      }
    },
    exportCourse () {
      if (this.beforeBatch()) {

      }
    },
    deleteCourse (row) {
      if (row || this.beforeBatch()) {
      } else {
        return false
      }
      let param = {
        ids: row ? row.id : this.selectIds.join()
      }
      this.$confirm('确定删除该课程?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { code } = await deleteCourseFn(param)
          if (code == 1) {
            this.$message.success('删除成功')
            this.getAllCourseFn()
          }
        }).catch(() => {
        })
    },
    async changeCourseState (row) {
      let param = {
        id: row.id,
        state: row.state
      }
      const { code } = await updateCourseStateFn(param)
      if (code == 1) {
        this.$message.success('修改成功')
      }
    },
    async getAllCourseFn () {
      this.CourseListParams = Object.assign(this.CourseListParams, this.selectForm)
      const { data } = await getAllCourse(this.CourseListParams)
      this.tableData = data.records
      this.pagination.total = data.total
    },
    resetForm() {
      this.form = {
        name: '',
        state: 1,
        scoreCalculateType: 1,
        scoreType: 1,
        exemptExam: 0,
        passScore:'',
        excellentScore:'',
        form_gradeList: [
          {score: 85, name: '优秀'},
          {score: 60, name: '及格'}
        ],
        useCalculator: 0,
        useMicroPhone: 0,
        specialInputting: '',
        haveSubCourse: 0,
        outputScore: 0,
        outputScoreSub: 0
      }
    },
    addAfter () {
      this.cancelDialog()
      this.getAllCourseFn()
    },
    changeSize(num) {
        this.CourseListParams.size=num
        this.getAllCourseFn()
    },
    changePage(p) {
        this.CourseListParams.page=p
        this.getAllCourseFn()
    },
    getResult () {
      this.CourseListParams.page = 1
      this.getAllCourseFn()
    },
    changeHaveSubCourse(val){
      if(val == 1){
        this.form.scoreCalculateType = 1;
        this.form.scoreType = 1;
      }
      this.form.outputScore = 0;
      this.form.outputScoreSub = 0;
    },
    changeSwitchState(val){
      this.form.outputScore = 0;
      this.form.outputScoreSub = 0;
    },
  }
}
</script>
<style lang="less" scoped>
.CourseBox {
  .searchCon {
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    .searchMain {
      flex: 1;
    }
    .searchBtn {
      flex-shrink: 0;
      width: 72px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .mainCon {
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
  }
}
.tipIcon{
    position: relative;
    .tips {
      font-size: 13px;
      position: absolute;
      color: #fff;
      width: 176px;
      text-align: center;
      padding: 10px;
      top: -48px;
      left: -90px;
      background: rgba(0, 0, 0, 0.85);
    }
    .tips::after{
      content: '';
      border: 5px solid transparent;
      border-top-color: rgba(0, 0, 0, 0.85);
      position: absolute;
      top: 33px;
      left: 96px;
    }
}
.rateStyle {
    .el-input {
        width: 120px;
        height: 36px;
    }
    em {
        position: relative;
        margin-left: -25px;
        z-index: 1;
        font-style:normal
    }
}
.gradeStyle {

    .el-input.long{
        width: 160px;
        height: 36px;
    }
    .el-input.short{
        width: 80px;
        height: 36px;
        margin-left: 10px;
    }
    /deep/ .el-input__inner {
      padding: 8px !important;
    }
}
.ml42{
  margin-left: 42px;
}
.courseSwitchCss{
  position: relative;
  border:1px solid #ccc;
  padding:15px;
  border-radius: 10px;
  margin-bottom: 18px;
  .switch1 , .switch2{
    line-height: 30px;
  }
  font{
    color: red;
  }
}
.courseSwitchCss::before {
  content: '';
  position: absolute;
  top: -10px;
  left: var(--arrow-position);
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ccc;
}
.courseSwitchCss::after {
  content: '';
  position: absolute;
  top: -9px;
  left: var(--arrow-position);
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid white;
}
</style>
